<ng-container *transloco="let t; prefix: 'orders.customerConfiguration'">
  @if (customer(); as company) {
    <mat-card class="customer-summary" appearance="outlined">
      <mat-card-content class="customer-summary-content">
        <span class="customer-summary-name headline-small-emphasized">{{ company.ragioneSociale }}</span>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('taxCode') }}</span>
          <span class="body-large">{{ company.codiceFiscale || '—' }}</span>
        </div>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('vatNumber') }}</span>
          <span class="body-large">{{ company.partitaIva || '—' }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="banking-heading">
      <span class="title-medium-emphasized">{{ t('bankingTitle') }}</span>
      <a matButton [routerLink]="['/new-order-proposal/configure-customer/contacts']" [queryParams]="{ id: proposalId }">{{ t('backToContacts') }}</a>
    </div>

    <form class="banking-form" [formGroup]="form" (ngSubmit)="continue()">
      <div class="banking-fields">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('paymentType') }}</mat-label>
          <mat-select formControlName="paymentType" [placeholder]="t('selectZone')">
            <mat-option [value]="null">{{ t('noPaymentType') }}</mat-option>
            @for (payment of paymentTypes; track payment.value) {
              <mat-option [value]="payment.value">{{ payment.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('abiDescription') }}</mat-label>
          <input matInput formControlName="abiDescription">
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('cabDescription') }}</mat-label>
          <input matInput formControlName="cabDescription">
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('sdiCode') }}</mat-label>
          <input matInput formControlName="sdiCode">
        </mat-form-field>
      </div>

      <div class="banking-upload">
        <div class="banking-upload-heading">
          <span class="title-medium-emphasized">{{ t('uploadBankingForm') }}</span>
          <!-- TODO: Collegare il template ufficiale quando sarà fornito il file o l'endpoint di download. -->
          <button matButton type="button" class="download-template" disabled>
            <span class="download-template-label">
              <i class="fa-regular fa-download" aria-hidden="true"></i>
              <span>{{ t('downloadTemplate') }}</span>
            </span>
          </button>
        </div>
        <input #fileInput type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" hidden (change)="chooseFile($event)">
        <div class="banking-dropzone" [class.banking-dropzone--dragging]="dragging()" (dragover)="dragOver($event)" (dragleave)="dragging.set(false)" (drop)="dropFile($event)">
          <i class="fa-regular fa-arrow-up-from-bracket upload-icon" aria-hidden="true"></i>
          <span class="body-large">{{ t('attachDocument') }}</span>
          <span class="body-medium">{{ t('bankingFileHint') }}</span>
          <button matButton type="button" (click)="fileInput.click()">{{ t('browseFiles') }}</button>
        </div>
        @if (configuration.bankingDocument(); as document) {
          <div class="banking-file" role="status">
            <span class="body-medium">{{ document.name }}</span>
            <button matIconButton type="button" [attr.aria-label]="t('removeDocument')" (click)="removeFile()"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
          </div>
        }
        @if (fileError(); as error) {
          <span class="banking-file-error body-medium" role="alert">{{ t(error) }}</span>
        }
      </div>

      <mat-checkbox formControlName="vatExempt">{{ t('vatExempt') }}</mat-checkbox>
      <div class="banking-actions">
        <button matButton="filled" type="submit" [disabled]="!configuration.destinationForConfiguration() || !!fileError()">{{ t('continue') }}</button>
      </div>
    </form>
  } @else {
    <div class="banking-state">
      <span class="body-large">{{ t('missingCustomer') }}</span>
      <a matButton="outlined" [routerLink]="['/new-order-proposal/new-customer']" [queryParams]="{ id: proposalId }">{{ t('backToSearch') }}</a>
    </div>
  }
</ng-container>
